import * as React from 'react';
import {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Customer from "./Customer";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {axiosInstance} from "../utils/axiosUtils";
import FutureMessages from "./FutureMessages";


export default function Customers({
                                      customersData,
                                      customersToSync,
                                      customersToDelete,
                                      expired,
                                      withMessageLog,
                                      inProcess,
                                      overridePhoneNumber,
                                      templates,
                                      updateCustomersData
                                  }) {
    const [data, setData] = useState(<div>טוען...</div>);
    const [selectedDay, setSelectedDay] = useState(0);
    const handleSelectedDayChange = (event, newTabName) => {
        setSelectedDay(newTabName);
    };
    const renderDaysOfWeekTabsSorted = () => {
        const daysOfWeek = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
        const currentDayIndex = new Date().getDay();
        const sortedDaysOfWeek = daysOfWeek.slice(currentDayIndex).concat(daysOfWeek.slice(0, currentDayIndex));
        return sortedDaysOfWeek.map((day, index) =>  <Tab key={index} sx={{color: 'white'}} label={day}/>);
    };
    const renderFutureMessages = (messages) => {
        const futureMessages = messages.filter(item => item.customer.phone && item.futureMessageWithActionLogForWeek.length > 0);
        return <FutureMessages customersToSync={customersToSync} customersData={futureMessages} customersToDelete={customersToDelete}
                               overridePhoneNumber={overridePhoneNumber} templates={templates} updateCustomersData={updateCustomersData}/>
    }
    const renderInProcessMessages = (messages) => {
        const filteredCustomersData = messages.filter(item => item.customer.phone && item.inProcessScheduledMessageWithActionLog.length > 0);
        return (<Box sx={{p: 3}}>
            {
                filteredCustomersData.sort((a, b) => {
                    const actionLogA = a.inProcessScheduledMessageWithActionLog[0]?.actionLogs.find(log => log.action === "accepted");
                    const actionLogB = b.inProcessScheduledMessageWithActionLog[0]?.actionLogs.find(log => log.action === "accepted");

                    if (actionLogA && actionLogB) {
                        return new Date(actionLogB.created) - new Date(actionLogA.created);
                    } else if (actionLogA) {
                        return -1;
                    } else if (actionLogB) {
                        return 1;
                    } else {
                        return 0;
                    }
                }).map((item, index) => {
                    return (
                        <div key={index}>
                            <Customer updateCustomersData={updateCustomersData} templates={templates}
                                      overridePhoneNumber customer={item.customer}
                                      scheduledMessageWithActionLog={item.inProcessScheduledMessageWithActionLog}
                                      changed={customersToSync ? customersToSync.includes(item.customer.id) : false}
                                      deleted={customersToDelete ? customersToDelete.includes(item.customer.id) : false}
                            />
                        </div>
                    )
                })
            }
        </Box>);
    }
    const renderExpiredMessages = (messages) => {
        const filteredCustomersData = messages.filter(item => item.customer.phone && item.expiredScheduledMessageWithActionLog.length > 0);
        //const filteredCustomersData = messages.filter(item => item.customer.phone);
        return (<Box sx={{p: 3}}>
            {
                filteredCustomersData.sort((a, b) => {
                    const scheduledMessageDateA = a.expiredScheduledMessageWithActionLog[0]?.scheduledMessageDateBy3LastOrders;
                    const scheduledMessageDateB = b.expiredScheduledMessageWithActionLog[0]?.scheduledMessageDateBy3LastOrders;

                    if (scheduledMessageDateA && scheduledMessageDateB) {
                        return new Date(scheduledMessageDateB) - new Date(scheduledMessageDateA);
                    } else if (scheduledMessageDateA) {
                        return -1;
                    } else if (scheduledMessageDateB) {
                        return 1;
                    } else {
                        return 0;
                    }
                }).map((item, index) => {
                    return (
                        <div key={index}>
                            <Customer updateCustomersData={updateCustomersData} templates={templates}
                                      overridePhoneNumber customer={item.customer}
                                      scheduledMessageWithActionLog={item.expiredScheduledMessageWithActionLog}
                                      changed={customersToSync ? customersToSync.includes(item.customer.id) : false}
                                      deleted={customersToDelete ? customersToDelete.includes(item.customer.id) : false}/>
                        </div>
                    )
                })
            }
        </Box>);
    }

    useEffect(() => {
        if (!withMessageLog) {
            const withoutMessageLog = (<Box sx={{p: 3}}>
                {
                    customersData.map((item, index) => {

                        return !item.customer.phone && (
                            <div key={index}>
                                <Customer updateCustomersData={updateCustomersData} templates={templates}
                                          overridePhoneNumber customer={item.customer}
                                          changed={customersToSync ? customersToSync.includes(item.customer.id) : false}
                                          deleted={customersToDelete ? customersToDelete.includes(item.customer.id) : false}/>
                            </div>
                        )
                    })
                }
            </Box>);
            setData(withoutMessageLog);
        } else if (expired) {
            const expiredMessages = renderExpiredMessages(customersData);
            setData(expiredMessages);
        } else if (inProcess) {
            const inProcessMessages = renderInProcessMessages(customersData);
            setData(inProcessMessages);
        } else {
            const futureMessages = renderFutureMessages(customersData);
            setData(futureMessages);
        }
    }, [customersData, customersToSync, customersToDelete]);
    return (
        <div>
            {data}
        </div>
    );
}
